import { OperationExport } from 'screens/Applications&WorkOrders/Hooks/useOperationPdf';
import { OperationType } from 'components/RecordsListView/constants';
import { OperationDetails } from 'screens/Applications&WorkOrders/Components/types';
import useQueuedPdfDownload from 'components/LinkedRecordOverviewDrawer/useQueuedPdfDownload';

interface UseDrawerPdfDownloadParams {
  operation: OperationDetails | undefined;
  operationType: OperationType;
  userId: string;
  isOpen: boolean;
  hasFailed?: boolean;
}

const useDrawerPdfDownload = ({
  operation,
  operationType,
  userId,
  isOpen,
  hasFailed = false
}: UseDrawerPdfDownloadParams) =>
  useQueuedPdfDownload({
    record: operation,
    operationType,
    userId,
    isOpen,
    hasFailed,
    renderPdf: ({ exportPdfEnglish }, record) =>
      exportPdfEnglish({
        ...record,
        name: record.name,
        products: record.products ?? [],
        properties: record.properties ?? [],
        cropSeasonIds: record.cropSeasonIds ?? []
      } as OperationExport)
  });

export default useDrawerPdfDownload;
